<template>
    <div>           
        <div>
            <el-form :inline="true" :model="receiptForm"   style="text-align:left;" label-width="75px">
                <el-row style="text-align:left;">                    
                    <el-radio-group v-model="receiptForm.state" style="margin-bottom: 10px;" @change="changeState">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button label="CHECK">待审核</el-radio-button>
                            <el-radio-button label="ACCEPTING">受理中</el-radio-button>
                            <el-radio-button label="FILL">待补充</el-radio-button>
                            <el-radio-button label="FINISH">已完成</el-radio-button>
                            <el-radio-button label="CLOSE">已关闭</el-radio-button>
                    </el-radio-group>                    
                </el-row>
                <el-row>
                    <el-col :span="9">
                        <el-form-item label="综合查询:">
                            <el-input v-model="receiptForm.name" placeholder="请输入受理单单号/客户姓名/客户电话" :clearable="true"  class="query-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="延保产品名称:" label-width="100px">
                            <My-Select v-model="receiptForm.prodName" :objSelect="receiptForm.prodName" :options="ewProductList" :placeholder="ewPlaceholder"
                                :optionBind="optionBindEw"  @changeSelct="changeEwSelct"></My-Select>                
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="省市区:" class="select-name">
                           <el-cascader
                                v-model="receiptForm.area"                            
                                :props="queryProps"
                                clearable
                                placeholder="请选择省市区"
                            ></el-cascader>              
                        </el-form-item>
                    </el-col>                       
                </el-row> 
                <el-row >
                    <el-col :span="9">
                        <el-form-item label="服务项目:" class="service-select">
                            <My-Select v-model="receiptForm.serviceCode" :objSelect="receiptForm.serviceCode" :options="serviceList" :placeholder="servicePlaceholder"
                            :optionBind="optionBindService"  @changeSelct="changeServiceSelct"></My-Select>                 
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="品牌:" label-width="99px">
                            <My-Select v-model="receiptForm.dicBrandCode" :objSelect="receiptForm.dicBrandCode" :options="prodBrandList" :placeholder="brandPlaceholder"
                            :optionBind="optionBindBrand"  @changeSelct="changeBrandSelct"></My-Select>                  
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" >
                        <el-form-item label="品类:" class="category-select">
                            <My-Select v-model="receiptForm.dicTypeCode" :objSelect="receiptForm.dicTypeCode" :options="categoryList" :placeholder="categoryPlaceholder"
                            :optionBind="optionBindCategory"  @changeSelct="changeCategorySelct"></My-Select>                 
                        </el-form-item>
                    </el-col>                       
                </el-row>
                <el-row >
                    
                    <el-col :span="14">
                        <el-form-item label="建单时间:" class="date-time">
                                <el-date-picker
                                    v-model="receiptForm.createTimeStart"
                                    type="datetime"
                                    placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <span> - </span>   
                                <el-date-picker
                                    v-model="receiptForm.createTimeEnd"
                                    type="datetime"
                                    placeholder="结束时间" 
                                    default-time = "23:59:59"
                                    value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>        
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-button type="primary" plain @click="query()">查询</el-button> 
                    </el-col>                        
                </el-row>
            </el-form>
        </div>    
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable" :showTag="showTag">           
                <template #operation="scope">        
                    <el-button size="mini" v-show="scope.row.state=='CHECK'" type="text" @click="receiptEditor('approval',scope.row)">审核</el-button>
                    <el-button size="mini" v-show="scope.row.state=='ACCEPTING'" type="text" @click="receiptEditor('deal',scope.row)">处理</el-button>
                    <el-button size="mini" v-show="scope.row.state=='ACCEPTING'" type="text" @click="receiptEditor('finish',scope.row)">完成</el-button>
                    <el-button size="mini" v-show="scope.row.state=='ACCEPTING'" type="text" @click="receiptEditor('close',scope.row)">关闭</el-button>
                </template>
            </My-table> 
        </div>
        <el-dialog :title="title" :visible.sync="acceptStateDialog" :close-on-click-modal=false width="500px"  >
            <el-row style="text-align: left">
                <el-col :span="15">
                    <span>单号:{{this.acceptCode}}</span>
                </el-col>
                <el-col :span="9">
                    <el-link type="primary" :underline="false" @click="checkAcceptProfile()">查看延保单及历史受理单</el-link>
                </el-col>
            </el-row>
            <el-divider class="divider-class"></el-divider>      
            <el-form :model="acceptForm"  :rules="rules" ref="acceptForm" label-width="110px" label-suffix=":" style="text-align: left">
                <div v-show="approvalDialog">
                    <el-form-item label="审核结果" prop="auditResults">
                        <el-radio-group v-model="acceptForm.auditResults" @change="changeRadio" >
                            <el-radio label="ACCEPT">受理</el-radio>
                            <el-radio label="REFUSE">拒绝受理</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div v-show="typeDialog">
                    <el-form-item :label="typeLabel" prop="mode">
                        <My-Select class="reject-class" v-model="acceptForm.mode" :objSelect="acceptForm.mode" :options="options" :placeholder="placeholderTypeName"
                          @changeSelct="changeType"></My-Select>
                    </el-form-item>                   
                </div>
                <div >
                    <el-form-item label="需补充资料" v-show="addTag" prop="machineMode">
                        <el-radio-group v-model="acceptForm.machineMode" @change="changeRadio" >
                            <el-radio v-for="(item,index) in addInformationList " :key="index" :label="item.enumKey" >{{item.enumValue}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="机器处理方式" v-show="handlingTag" prop="machineMode">
                        <el-radio-group v-model="acceptForm.machineMode" @change="changeRadio" >
                            <el-radio v-for="(item,index) in machineModeList" :key="index" :label="item.enumKey">{{item.enumValue}}</el-radio>                
                        </el-radio-group>
                    </el-form-item> 
                    <el-form-item label="收货信息" v-show="receivingTag" prop="address">
                        <el-select :title="acceptForm.address" v-model="acceptForm.address" placeholder="请选择收货信息" class="reject-class">
                            <el-option
                                v-for="(item,index) in addressList"
                                :key="index"
                                :label="item.userName+'/'+item.phone+'/'+item.addressLink+'/'+item.address"
                                :value="item.userName+'/'+item.phone+'/'+item.addressLink+'/'+item.address"
                                style="height:100px"
                                >
                                <div >
                                    <div>{{item.userName}}/{{item.phone}}</div> 
                                    <div>{{item.addressLink}}</div>
                                    <div>{{item.address}}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-show="reasonDialog">
                    <el-form-item :label="rejectName" prop="reason">
                        <My-Select class="reject-class" v-model="acceptForm.reason" :objSelect="acceptForm.reason" :options="reasonList" :placeholder="placeholderName" 
                        :optionBind="optionReason" @changeSelct="changeReason"></My-Select>
                    </el-form-item>
                </div> 
                <div v-show="closeDialog">
                    <el-form-item label="关闭延保单" prop="closeState">
                        <el-radio-group v-model="acceptForm.closeState" >
                            <el-radio label="Y">是</el-radio>
                            <el-radio label="N">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <el-form-item :label="labelName" prop="remarks">
                    <el-input type="textarea" maxlength="200" rows="5" show-word-limit v-model="acceptForm.remarks" class="textarea-class" placeholder="请填写审核备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="submitForm('acceptForm')">确定</el-button>
                <el-button @click="resetForm('acceptForm')">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="延保单及历史受理单概要" :visible.sync="acceptProfileDialog" :close-on-click-modal=false width="1200px"  >
            <el-row style="text-align: left"><span><strong>延保单概要</strong></span></el-row>   
            <el-form :model="acceptProfileForm"  ref="acceptProfileForm" label-width="120px" label-suffix=":" style="text-align: left">
                <el-row>
                    <el-col :span="12">
                        <My-span label="延保单号" v-model="acceptProfileForm.extensionPolicyId" :objInput="acceptProfileForm.extensionPolicyId"></My-span>
                    </el-col>
                    <el-col :span="12">
                         <My-span label="延保状态" v-model="acceptProfileForm.stateName" :objInput="acceptProfileForm.stateName"></My-span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <My-span label="延保产品名称" v-model="acceptProfileForm.prodName" :objInput="acceptProfileForm.prodName"></My-span>
                    </el-col>
                    <el-col :span="12">
                        <My-span label="延保生效时间" v-model="acceptProfileForm.effectiveDate" :objInput="acceptProfileForm.effectiveDate"></My-span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <My-span label="保障期限" v-model="acceptProfileForm.expiryDateStr" :objInput="acceptProfileForm.expiryDateStr"></My-span>
                    </el-col>
                    <el-col :span="12">
                        <My-span label="房屋/收货地址" v-model="acceptProfileForm.address" :objInput="acceptProfileForm.address"></My-span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <My-span label="客户姓名" v-model="acceptProfileForm.customer" :objInput="acceptProfileForm.customer"></My-span>
                    </el-col>
                    <el-col :span="12">
                        <My-span label="客户电话" v-model="acceptProfileForm.customerPhone" :objInput="acceptProfileForm.customerPhone"></My-span>
                    </el-col>
                </el-row>
                <el-divider class="divider-class"></el-divider>
                <el-row style="text-align:left;margin:5px 0px"><span><strong>历史受理单</strong></span></el-row>
                <el-row>
                    <el-col :span="6">共计:{{acceptProfileForm.totalStr}}</el-col>
                    <el-col :span="6">已完成受理单:{{acceptProfileForm.finishStr}}</el-col>
                    <el-col :span="6">已关闭受理单:{{acceptProfileForm.closeStr}}</el-col>
                    <el-col :span="6">其余受理单:{{acceptProfileForm.otherStr}}</el-col>
                </el-row>
                <el-table :data="acceptProfileForm.acceptPolicyOrderDtoList" border style="width: 100%;margin-top:5px;">
                    <el-table-column label="受理单单号">
                        <template slot-scope="scope">
                            <p > {{ scope.row.acceptPolicyId }}</p>                                
                        </template>
                    </el-table-column>
                    <el-table-column label="受理单状态" >
                        <template slot-scope="scope">
                            <p>  {{ scope.row.stateName }}</p>                                       
                        </template>
                    </el-table-column>
                    <el-table-column label="处理方式" >
                        <template slot-scope="scope">
                            <p> {{ scope.row.modeName }}</p>                              
                        </template>
                    </el-table-column>
                    <el-table-column label="预约服务项目" >
                        <template slot-scope="scope">
                            <p> {{ scope.row.serviceItemName }}</p>                              
                        </template>
                    </el-table-column>
                    <el-table-column label="延保生效时间" >
                        <template slot-scope="scope">
                            <p> {{ scope.row.effectiveDate }}</p>                              
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-form>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next,jumper"
                :total="totalNum">
            </el-pagination>
            <div slot="footer" style="text-align:center">                
                <el-button @click="acceptProfileDialog=false">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="受理单详情"  :visible.sync="acceptDetailDialog" :close-on-click-modal=false width="1200px">
            <el-row style="text-align: left">
                <el-col :span="22">
                    <span>受理单号:{{this.acceptCode}}</span>
                </el-col>
                <el-col :span="2">
                    <span>状态:{{this.sName}}</span>
                </el-col>
            </el-row>
            <el-divider class="divider-class"></el-divider> 
            <el-form :inline="true"   label-width="100px" label-suffix=":" style="text-align: left;">
                <div  v-for="(item,index) in formList" :key="index" >
                <div style="text-align: left;margin-left: 30px;font-weight: bold" v-if="item.propertyInfos.length>0 && item.propertyName!='syslayer'">{{item.propertyName}}</div>
                <div v-if="item.propertyInfos.length>0 && item.propertyName!='syslayer'">
                    <el-row v-for="(item1,index1) in item.propertyInfos" :key="index1" v-if="index1%2==0">              
                    <el-col :span="12">
                        <Component-Form :item="getList(item,index1)"></Component-Form>
                    </el-col>
                    <el-col :span="12">
                        <Component-Form :item="getList(item,index1+1)"></Component-Form>
                    </el-col>            
                    </el-row> 
                </div >          
                </div>
            </el-form>
        <div slot="footer" style="text-align:center">      
            <el-button  @click="acceptDetailDialog = false">关闭</el-button>
        </div>
    </el-dialog>          
    </div>
</template>

<script>
import  asyncApi   from '../../api/asyncApi';
import common from "../../../public/static/common.js";
export default { 
    name: 'receiptManagement',
    data(){
        let recme = this;
        return{
            extensionPolicyId:'',
            placeholderName:'',
            pageNum: 1, // 当前页，默认1
            pageSize: 10, // 每页行数，默认10         
            totalNum: 10, // 总数           
            rejectName:'',
            labelName:'',
            title:'',
            acceptCode:'',
            sName:'',
            optionReason:{
                label:"enumValue",
                value:"enumValue"
            },
            optionBindEw:{
                label:"prodName",
                value:"prodCode"
            },
            optionBindService:{
                label:"serviceName",
                value:"serviceCode"
            },
            optionBindBrand:{
                label:"dicBrandName",
                value:"dicBrandCode"
            },
            optionBindCategory:{
                label:"dicTypeName",
                value:"dicTypeCode"
            },
            ewPlaceholder:'请选择延保产品',
            placeholder:'请选择延保产品',
            brandPlaceholder:'请选择品牌',
            categoryPlaceholder:'请选择品类',
            servicePlaceholder:'请选择服务项目',
            receiptForm:{
                name:'',
                prodName:'',
                area:[],
                areaProvince:'',
                areaCity:'',
                areaCounty:'',
                createTimeStart:'',
                createTimeEnd:'',
                dicBrandCode:'',
                dicTypeCode:'',
                serviceCode:'',
                state:''
            },
            acceptForm:{
                acceptPolicyId:'',
                auditResults:'',
                address:'',
                closeState:'',
                machineMode:'',
                mode:'',
                reason:'',
                remarks:'',
                applyUser:''
            },
            acceptProfileForm:{
                extensionPolicyId:'',
                stateName:'',
                prodName:'',
                effectiveDate:'',
                expiryDateStr:'',
                address:'',
                customer:'',
                customerPhone:'',
                totalStr:'',
                finishStr:'',
                closeStr:'',
                otherStr:'',
                acceptPolicyOrderDtoList:[{
                        acceptPolicyId:'',
                        stateName:'',
                        mode:'',
                        serviceItem:'',
                        effectiveDate:''
                    }
                ]
            },
            // 列表配置
            configurationData:[
                {
                    title: '受理单单号',
                    propertys: 'acceptPolicyId',
                    width: '',
                    link:this.linkToinfo
                },
                {
                    title: '受理单状态',
                    propertys: 'stateName',
                    width: '100px'
                },
                {
                    title: '处理方式',
                    propertys: 'mode',
                    width: '',
                    format:this.formatMode
                },
                {
                    title: '预约服务项目',
                    propertys: 'serviceItemName',
                    width: ''
                },
                {
                    title: '延保产品名称',
                    propertys: 'prodName',
                    width: ''
                },
                {
                    title: '客户姓名/电话',
                    propertys: 'customerInfo',
                    width: ''
                },
                {
                    title: '收货地址/房屋地址',
                    propertys: 'address',
                    width: ''
                },
                {
                    title: '延保单单号',
                    propertys: 'extensionPolicyId',
                    width: ''
                },
                {
                    title: '延保单状态',
                    propertys: 'extensionPolicyStateName',
                    width: '80px'
                },
                {
                    title: '延保品类',
                    propertys: 'typeName',
                    width: '100px'
                },
                {
                    title: '延保生效时间',
                    propertys: 'effectiveDate',
                    width: '100px'
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/acceptPolicyOrder/page',
                param:''
            },
            showTag:false,
            options:[
                {"key":'ONSIDE_APPRAISAL',"value":'上门鉴定',"groupTag":'1'},
                {"key":'ONSIDE_REPAIR',"value":'上门维修',"groupTag":'1'},
                {"key":'SEND_APPRAISAL',"value":'邮寄鉴定',"groupTag":'2'},
                {"key":'SEND_REPAIR',"value":'邮寄维修',"groupTag":'2'},
                {"key":'SELF_APPRAISAL',"value":'自行鉴定',"groupTag":'3'}, 
                {"key":'SUPPLEMENTARY_INFO',"value":'补充资料',"groupTag":'3'},                
                {"key":'BACK_OFF',"value":'退机',"groupTag":'4'},
                {"key":'REPLACE',"value":'换机',"groupTag":'4'},
                {"key":'SUBSIDY',"value":'补贴',"groupTag":'5'}               
            ],
            queryProps:{
                value: 'name',
                label: 'name',
                children: 'cities' ,
                checkStrictly :true,
                lazy: true,
                async lazyLoad (node, resolve) {                  
                    const { level } = node;
                    let nodes = [];
      
                    if(level ==0){
                        await recme.getProvince();
                        nodes = recme.provinceList;
                    }
                    if(level ==1){
                        await recme.getCity(node.data.code);                       
                        nodes = recme.cityList;
                    }
                    if(level ==2){
                        await recme.getDistricts(node.data.code);                       
                        nodes = recme.districtList;
                        nodes.forEach(element => {
                            element.leaf = true;
                        });
                    }
                    setTimeout(() => {                       
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }, 200);
                }               
            },
             rules: {
                auditResults: [
                    { required: true, message: '请选择审核结果', trigger: 'blur' }
                ],
                mode: [
                    { required: true, message: '请选择受理方式/处理方式', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请选择收货信息', trigger: 'blur' }
                ],
                machineMode: [
                    { required: true, message: '请选择需补充资料/机器处理方式', trigger: 'blur' }
                ],
                closeState: [
                    { required: true, message: '请选择关闭延保单', trigger: 'blur' }
                ],
                reason: [
                    { required: true, message: '请选择驳回原因/关闭原因', trigger: 'blur' }
                ],
                remarks:[
                    { required: true, message: '请输入审核备注', trigger: 'blur' }
                ],
            },
            prodBrandList:[],            
            categoryList:[],
            serviceList:[],
            provinceList:[],
            cityList:[],
            districtList:[],
            ewProductList:[],
            prodBrandList:[],
            categoryList:[],
            acceptStateDialog:false,
            approvalDialog:false,//审核            
            reasonDialog:false,//驳回原因
            closeDialog:false,//关闭延保单            
            addTag:false,//需补充资料
            handlingTag:false,//机器处理方式            
            receivingTag:false,//收货信息,
            tagName:'',
            acceptProfileDialog:false,
            acceptDetailDialog:false,
            formList:[],
            reasonList:[],
            groupTag:'',
            typeDialog:'',
            typeLabel:'',
            placeholderTypeName:'',
            addressList:[],
            addInformationList:[],
            machineModeList:[]
        }
    },
    methods:{
        changeState(value){
          this.query();
        },
        formatMode(row){
            if(row.mode=='ONSIDE_APPRAISAL'){
			    return '上门鉴定'
            }else if(row.mode=='SEND_APPRAISAL'){
                return '邮寄鉴定'
            }else if(row.mode=='SELF_APPRAISAL'){
                return '自行鉴定'
            }else if(row.mode=='ONSIDE_REPAIR'){
                return '上门维修'
            }else if(row.mode=='SEND_REPAIR'){
                return '邮寄维修'
            }else if(row.mode=='BACK_OFF'){
                return '退机'
            }else if(row.mode=='REPLACE'){
                return '换机'
            }else if(row.mode=='SUBSIDY'){
                return '补贴'
            }else if(row.mode=='SUPPLEMENTARY_INFO'){
                return '补充资料'
            }else if(row.mode=='CLOSE'){
                return '关闭'
            }else if(row.mode=='FINISH'){
                return '完成'
            }
        },
        getList(item,index){
            return item.propertyInfos[index];
        },
        changeEwSelct(value){
            this.receiptForm.prodName=value;
        },
        changeBrandSelct(value){
            this.receiptForm.dicBrandCode=value;
        },
        changeCategorySelct(value){
            this.receiptForm.dicTypeCode=value;
        },
        changeServiceSelct(value){
            this.receiptForm.serviceItem=value;
        },
        changeMode(value){
            this.acceptForm.type=value;
        },
        changeReason(value){
            this.acceptForm.reason=value;
        },
        //处理方式
        changeType(value){
            this.labelName="审核备注";
            this.acceptForm.mode=value;
            this.groupTag=common.getVbyK(this.options,value,"key","groupTag");
            if(this.groupTag=='1'){
                this.addTag=false;
                this.handlingTag=false;              
                this.receivingTag=false;
                this.reasonDialog=false;
                this.closeDialog=false;
            }else if(this.groupTag=='2'){
                this.addTag=false;
                this.handlingTag=false;
                this.receivingTag=true;
                this.reasonDialog=false;
                this.closeDialog=false;
            }else if(this.groupTag=='3'){
                this.addTag=true;       
                this.receivingTag=false;
                this.handlingTag=false;
                this.reasonDialog=false;
                this.closeDialog=false;
                this.acceptForm.machineMode="SINGLE";
            }else if(this.groupTag=='4'){                
                this.handlingTag=true;
                this.receivingTag=false;
                this.addTag=false;
                this.reasonDialog=false;
                this.closeDialog=false;
                this.acceptForm.machineMode="ONSIDE";               
            }else if(this.groupTag=='5'){
                this.closeDialog=true;
                this.addTag=false;
                this.handlingTag=false;                
                this.receivingTag=false;
                this.reasonDialog=false;
                this.labelName="完成备注";
            }
            

        },
        query(){
            let param=Object.assign({},this.receiptForm); 
            if(param.area[0]){
                param.areaProvince=param.area[0];
            }
            if(param.area[1]){               
                param.areaCity=param.area[1];
            }
            if(param.area[2]){
                param.areaCounty=param.area[2];
            }

            this.getTableParam.param=param;
            this.$refs.myTable.query(1);
        },
        receiptEditor(tag,row){
            this.acceptForm=common.emptyModel(this.acceptForm); 
            this.extensionPolicyId=row.extensionPolicyId;
            this.acceptCode=row.acceptPolicyId;
            this.acceptForm.acceptPolicyId=row.acceptPolicyId;
            this.sName=row.stateName;
            this.acceptStateDialog=true;
            this.getAddInformationList();
            this.getMachineModeList();            
            if(tag=='approval'){//审核
                this.title="审核";
                this.tagName="approval";
                this.approvalDialog=true;
                this.typeDialog=true;
                this.typeLabel="受理方式";
                this.placeholderTypeName="请选择受理方式"
                this.acceptForm.auditResults='ACCEPT'//受理
                this.reasonDialog=false;                
                this.closeDialog=false;
                this.addTag=false;
                this.handlingTag=false;                
                this.receivingTag=false;
                this.labelName="审核备注";
                this.rejectName="驳回原因";
                this.placeholderName="请选择驳回原因";
                this.getRejectedList();
                this.getAddressList();
            }else if(tag=='deal'){//处理
                this.title="处理";
                this.tagName="deal";
                this.approvalDialog=false;
                this.typeDialog=true;
                this.typeLabel="处理方式";
                this.placeholderTypeName="请选择处理方式"
                this.reasonDialog=false;
                this.acceptForm.mode="ONSIDE_APPRAISAL";
                this.addTag=false;
                this.handlingTag=false;
                this.closeDialog=false;
                this.receivingTag=false;
                this.getAddressList();
            }else if(tag=='finish'){//完成
                this.labelName="完成备注";
                this.title="完成";
                this.tagName="finish";
                this.closeDialog=true;
                this.approvalDialog=false;
                this.reasonDialog=false;               
                this.addTag=false;
                this.handlingTag=false;                
                this.receivingTag=false;
                this.typeDialog=false;
                this.acceptForm.closeState='Y';                
            }else if(tag=='close'){//关闭
                this.title="关闭";
                this.tagName="close";
                this.reasonDialog=true;
                this.closeDialog=false;
                this.approvalDialog=false;             
                this.addTag=false;
                this.handlingTag=false;                
                this.receivingTag=false;                
                this.typeDialog=false;
                this.rejectName="关闭原因";
                this.placeholderName="请选择关闭原因";
                this.getRejectedList();
            }
        },
        changeRadio(value){
            if(value=='ACCEPT'){  
                this.reasonDialog=false;
                this.typeDialog=true; 
                this.acceptForm.mode="ONSIDE_APPRAISAL"; 
            }else if(value=='REFUSE'){              
                this.reasonDialog=true;  
                this.typeDialog=false; 
                this.addTag=false;           
                this.receivingTag=false;
                this.handlingTag=false;   
                this.closeDialog=false;       
            }else if(value=='SINGLE'){
                this.addTag=true;           
                this.receivingTag=false;
                this.handlingTag=false;
            }else if(value=='INFORMATION'){
                this.addTag=true;           
                this.receivingTag=true;
                this.handlingTag=false;
            }else if(value=='ONSIDE'){
                this.handlingTag=true;
                this.receivingTag=false;
                this.addTag=false;
            }else if(value=='SEND'){                         
                this.receivingTag=true;
                this.handlingTag=true;
                this.addTag=false;                
            }
        },
        changeAddress(value){

        },
        submitForm(formName){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
          let url="/extwarapi/api/acceptPolicyOrder/check";
          let param=Object.assign({},this.acceptForm);
          let usercode=common.getCurrUser().userCode;
              param.applyUser=usercode;
          let validFields=[];
          if(this.tagName=="approval"){
            validFields.push("auditResults");            
            validFields.push("remarks");
            if(param.auditResults=='ACCEPT'){
                validFields.push("mode");
            }
          }
          if(this.tagName=="deal"){
            param.auditResults='ACCEPT';
            validFields.push("mode");
            if(this.groupTag=='2'){
                validFields.push("address");
            }
            if(this.groupTag=='3'){
                validFields.push("machineMode");
                if(param.machineMode=='INFORMATION'){
                    validFields.push("address");
                }
            }
            if(this.groupTag=='4'){
                validFields.push("machineMode");
                if(param.machineMode=='SEND'){
                    validFields.push("address");
                }
            }
            if(this.groupTag=='5'){
                validFields.push("closeState");
            }
          }
          if(this.tagName=="finish"){
            param.auditResults='ACCEPT';
            param.mode='FINISH';
            validFields.push("closeState");
          }
          if(this.tagName=="close"){
            param.auditResults='ACCEPT';
            param.mode='CLOSE';
            validFields.push("reason");
          }

          let me = this;
          let allValid = true;
          this.$refs[formName].validateField(validFields,(valid) => {
              if(valid.length>0){
                  allValid = false;
              }                
          });
          //console.log(param);
          if (allValid) {
              me.axios.post(url, param).then((resp) => {
                  if(resp.data.code=='0000'){
                      loading.close()
                      me.acceptStateDialog=false;
                      me.$refs["myTable"].query(1);  
                  }else{
                      this.$alert(resp.data.msg, '提示信息', {
                              confirmButtonText: '确定',
                              callback: action => {
                              
                              }
                            });
                      return;
                  }  
            
              }).catch((resp) => {
                  //console.log('error', resp); 
              })
          } else {
              //console.log('error submit!!',allValid);
              return false;
          }
        },
        resetForm(formName){
          this.acceptStateDialog=false;
          this.$refs[formName].resetFields();  
        },
        linkToinfo(row){
            this.acceptCode=row.acceptPolicyId;
            this.sName=row.stateName;
            this.acceptDetailDialog=true;
            this.getDetail(row);
        },
        getNodeCodeByState(row){
           
            let nodeCode="700";
            let formdetailcode=false;
            let clshide = ""

            if(row.state=='FILL'){            
                if(row.mode=="SEND_APPRAISAL" || row.mode=="SEND_REPAIR"){
                    //邮寄鉴定 邮寄维修
                    nodeCode="705"
                }
                if(row.mode=="SELF_APPRAISAL"){
                    // 自行鉴定
                    nodeCode="700"
                }
                if(row.mode=="SUPPLEMENTARY_INFO"){//补充资料
                    
                    if(row.machineMode && row.machineMode=="3"){
                        //补充鉴定单
                        nodeCode="700"
                    }else{
                        nodeCode="705"
                    }
                    
                }
                formdetailcode = true;
                clshide="";
            }else{
                nodeCode="710";
                formdetailcode = false;
                clshide="ss-hid";
            }

            return nodeCode;
        },
        getDetail(row){
            let orderCode = row.acceptPolicyId;
            let nodeCode = this.getNodeCodeByState(row);
            let url="/extwarapi/api/acceptPolicyOrder/formDetail";

          let param={
              orderCode:orderCode,
              formCode:"150",
              type:"accept",
              nodeCode:nodeCode
            }
          this.axios.post(url, param).then((resp) => {
              if(resp.data.code=='0000'){
                 this.formList=resp.data.result.propertyInfos;
              }      
          }).catch((resp) => {
              //console.log('error', resp); 
          })
        },
        checkAcceptProfile(){
            this.acceptProfileDialog=true;
            let url="/extwarapi/api/acceptPolicyOrder/getHistoryAcceptOrder";
            this.axios.post(url, {code:this.extensionPolicyId}).then((resp) => {
                if(resp.data.code=='0000'){
                   this.acceptProfileForm=resp.data.result;
                   this.totalNum=resp.data.result.acceptPolicyOrderDtoList.length;
                } 
            
            }).catch((resp) => {
                //console.log('error', resp); 
            })
        },
        handleSizeChange(val) {  
            this.pageSize = val;        
        },
        handleCurrentChange(val) {  
            this.pageNum = val;
        },
        //获取品牌产品字典
        async getProdBrand(){
            let url ="/extwarapi/api/dicProdBrand/getBrandEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.prodBrandList=data.result;
            }
        },
        //获取品类产品字典
        async getCategory(){
            let url ="/extwarapi/api/dicProdType/getTypeEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.categoryList=data.result;
            }
        },
        //获取服务项目数据字典
        async getServiceList(){
            let url ="/extwarapi/api/dicServiceItem/getServiceEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.serviceList=data.result;
            }
        },
        //获取延保产品字典
        async getEwProduct(){
            let url ="/extwarapi/api/extension/getProdName";
            let data = await asyncApi.post(url,'');  
            if(data.code=='0000'){
                this.ewProductList=data.result;
            } 
        },
        //获取驳回原因字典
        async getRejectedList(){
            let url ="/extwarapi/api/tools/getEnumsByCode";
            let data = await asyncApi.post(url,{code:'rejected'});  
            if(data.code=='0000'){
              this.reasonList=data.result;
            }
        }, 
        //获取收货地址字典
        async getAddressList(){
            let url ="/extwarapi/api/addressManage/getAllAddress";
            let data = await asyncApi.post(url,{});  
            if(data.code=='0000'){
              this.addressList=data.result;
            }
        },
        //获取需补充资料字典
        async getAddInformationList(){
            let url ="/extwarapi/api/tools/getEnumsByCode";
            let data = await asyncApi.post(url,{code:'addInformation'});  
            if(data.code=='0000'){
              this.addInformationList=data.result;
            }
        },  
        //获取机器处理方式字典
        async getMachineModeList(){
            let url ="/extwarapi/api/tools/getEnumsByCode";
            let data = await asyncApi.post(url,{code:'machineMode'});  
            if(data.code=='0000'){
              this.machineModeList=data.result;
            }
        },  
        async  getProvince () { 
            let url ="/extwarapi/api/tools/getProvince";
            let data = await asyncApi.post(url,{});  
            if(data.code=='0000'){
                this.provinceList= common.conversionList(data.result,'provinceCode','code','provinceName','name');
            }
        },
        async  getCity (code) {
            let url ="/extwarapi/api/tools/getCity";
            let data = await asyncApi.post(url,{code:code});  
            if(data.code=='0000'){
                this.cityList= common.conversionList(data.result,'cityCode','code','cityName','name');
            }
        },
        async  getDistricts (code) {
            let url ="/extwarapi/api/tools/getDistricts";
            let data = await asyncApi.post(url,{code:code});  
            if(data.code=='0000'){
                this.districtList= common.conversionList(data.result,'districtCode','code','districtName','name');
            }
        },
    
    },
    mounted(){
        this.getProdBrand();
        this.getCategory();
        this.getServiceList();
        this.getProvince();
        this.getEwProduct();
    }
 
}
</script>
<style lang="scss" >

.service-select .el-input__inner{
    width: 300px;
}
.deal-type-class .el-input--suffix{
        margin-top: 6px;
}
.ss-hid{
  display:none;
}
.date-time .el-date-editor {
    // width: 134px;
    width: 190px;
  }

</style>